import { render, staticRenderFns } from "./FacilityTemplates.vue?vue&type=template&id=2c217b1a&scoped=true&"
import script from "./FacilityTemplates.vue?vue&type=script&lang=js&"
export * from "./FacilityTemplates.vue?vue&type=script&lang=js&"
import style0 from "./FacilityTemplates.vue?vue&type=style&index=0&id=2c217b1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c217b1a",
  null
  
)

export default component.exports